import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { Icon, type IconName } from '../Icon';
import styles from './Button.module.css';

export type ButtonType = 'primary' | 'default' | 'success' | 'warning' | 'danger' | 'info';
export type ButtonSize = 'default' | 'large' | 'small';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  children: ReactNode;
  htmlType?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  leadingIcon?: IconName;
  plain?: boolean;
  size?: ButtonSize;
  trailingIcon?: IconName;
  type?: ButtonType;
}

export function Button({ children, className, htmlType = 'button', leadingIcon, plain = false, size = 'default', trailingIcon, type = 'primary', ...buttonProps }: ButtonProps) {
  const classes = [styles.root, styles[type], plain ? styles.plain : '', className].filter(Boolean).join(' ');
  const iconSize = size === 'small' ? 'xs' : 'sm';

  return (
    <button className={classes} data-plain={plain || undefined} data-size={size} data-type={type} type={htmlType} {...buttonProps}>
      {leadingIcon ? <Icon name={leadingIcon} size={iconSize} /> : null}
      <span>{children}</span>
      {trailingIcon ? <Icon name={trailingIcon} size={iconSize} /> : null}
    </button>
  );
}
